import * as React from 'react';
import { Button, CardBody, CardFooter, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { HttpRequest } from '../../../util/http';
import { FontAwesomeIcon } from '../../ui/FontAwesomeIcon';
import { GetAllSegments } from '../../util';
import { ISegment } from '../interfaces';
import { SegmentParentSelect } from '../SegmentParentSelect';

interface ISegmentEditorProps {
  editMode?: ISegment
  onSuccess?: () => Promise<any> | void
  onCancel?: () => void
  className?: string
}

// tslint:disable-next-line:no-empty-interface
interface ISegmentEditorState {
  isSubmitting: boolean
  segments: ISegment[]
  useExisting: boolean
  fileColumnName: string
  fileValue: string
  segmentParentId: number | undefined
  segmentName: string
  sortOrder: number
  segmentValueName: string
  segmentAvid: string
  operator: string
  id: number
}

export class SegmentEditor extends React.Component<ISegmentEditorProps, ISegmentEditorState> {
  initState: ISegmentEditorState = {
    segments: [],
    isSubmitting: false,
    useExisting: true,
    fileColumnName: '',
    fileValue: '',
    segmentName: '',
    segmentParentId: undefined,
    sortOrder: 1,
    segmentValueName: '',
    segmentAvid: '',
    operator: '',
    id: 0,
  }

  state: ISegmentEditorState = { ...this.initState };

  componentWillMount() {
    const { editMode } = this.props

    if (this.isEditMode()) {
      const { fileColumnName, fileValue, useExisting, segmentName, sortOrder, segmentValueName, segmentAvid, operator, id } = editMode

      this.setState({ fileColumnName, fileValue, useExisting, segmentName, sortOrder, segmentValueName, segmentAvid, operator, id })
      this.state.segmentName = segmentName; //assure loadSegments has it loaded
    }

    this.loadSegments()
  }

  loadSegments() {
    return GetAllSegments().then((segments) => {
      const { segmentName } = this.state

      this.setState({ segments })

      if (this.isEditMode()) {
        const selectedSegmentParent = segments.find((s) => s.segmentName === segmentName)

        if (selectedSegmentParent) {
          const segmentParentId = selectedSegmentParent.id

          this.setState({ segmentParentId })
        }
      }
    })
  }

  submit(e: React.FormEvent<HTMLFormElement>) {
    const { segments, segmentParentId } = this.state
    const { fileColumnName, fileValue, useExisting, sortOrder, segmentValueName, operator, id } = this.state
    const selectedSegmentParent = segments.find((s) => s.id === segmentParentId)
    let segmentName = this.state.segmentName
    let segmentValueAvid = ''
    let segmentAvid = ''

    if (useExisting && selectedSegmentParent) {
      segmentValueAvid = selectedSegmentParent.segmentValueAvid
      segmentName = selectedSegmentParent.segmentName
      segmentAvid = selectedSegmentParent.segmentAvid
    }

    e.preventDefault()

    const method = 'POST'
    const endpoint = '/scripts/segments/save'
    const data = { segmentValueAvid, fileColumnName, fileValue, useExisting, segmentName, sortOrder, segmentValueName, segmentAvid, operator, id }
    const { onSuccess } = this.props

    this.setState({ isSubmitting: true })

    HttpRequest.fetch(endpoint, { data, method })
      .then(() => {
        let onSuccessPromise = onSuccess()

        if (!onSuccessPromise) {
          onSuccessPromise = Promise.resolve()
        }

        return onSuccessPromise.then(() => this.resetToInitState())
      })
      .finally(() => this.setState({ isSubmitting: false }))
  }

  resetToInitState() {
    this.setState({ ...this.initState })
  }

  isEditMode() {
    return !!this.props.editMode
  }

  render() {
    const { className, onCancel = () => ({}) } = this.props
    const { useExisting, isSubmitting } = this.state

    return (
      <Form onSubmit={(e) => this.submit(e)} className={className}>
        <CardBody className="bg-white">
          <Row>
            <Col md={6}>
              <Label>Parent Segment</Label>
              <FormGroup>
                <FormGroup check inline>
                  <Input type="radio" name="useExisting" id="useExistingSegment"
                    onChange={() => this.setState({ useExisting: true })}
                    checked={useExisting}
                    disabled={isSubmitting} />
                  <Label check htmlFor="useExistingSegment">Use Existing Segment</Label>
                </FormGroup>
                <FormGroup check inline>
                  <Input type="radio" name="useExisting" id="createNewSegment"
                    onChange={() => this.setState({ useExisting: false })}
                    checked={!useExisting}
                    disabled={isSubmitting} />
                  <Label check htmlFor="createNewSegment">Create New Segment</Label>
                </FormGroup>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label>File Column Name</Label>
                <Input type="text" required
                  readOnly={isSubmitting}
                  onChange={(e) => this.setState({ fileColumnName: e.target.value })}
                  value={this.state.fileColumnName} />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              {this.state.useExisting ?
                <FormGroup>
                  <Label>Current Parent Segment</Label>
                  <SegmentParentSelect required
                    readOnly={isSubmitting}
                    onChange={(segmentParentId) => this.setState({ segmentParentId })}
                    value={this.state.segmentParentId} />
                </FormGroup>
                :
                <FormGroup>
                  <Label>New Segment Parent</Label>
                  <Input type="text" required
                    readOnly={isSubmitting}
                    onChange={(e) => this.setState({ segmentName: e.target.value })}
                    value={this.state.segmentName} />
                </FormGroup>
              }

            </Col>
            <Col>
              <FormGroup>
                <Label>File Value</Label>
                <Input type="text" required
                  readOnly={isSubmitting}
                  onChange={(e) => this.setState({ fileValue: e.target.value })}
                  value={this.state.fileValue} />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Sort Order</Label>
                <Input type="number" required
                  min={0}
                  readOnly={isSubmitting}
                  onChange={(e) => this.setState({ sortOrder: Number(e.target.value) })}
                  value={this.state.sortOrder} />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label>New Child Segment Label</Label>
                <Input type="text" required
                  readOnly={isSubmitting}
                  onChange={(e) => this.setState({ segmentValueName: e.target.value })}
                  value={this.state.segmentValueName} />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
        <CardFooter className="d-flex justify-content-end">
          <Button color="danger" className="mr-2" type="submit"
            readOnly={isSubmitting}>
            <span>Submit&nbsp;</span>
            {isSubmitting &&
              <FontAwesomeIcon icon="cog" spin />
            }
          </Button>
          <Button color="light"
            onClick={() => onCancel()}
            readOnly={isSubmitting}>
            <span>Cancel</span>
          </Button>
        </CardFooter>
      </Form>
    )
  }
}
